import CountryRegionData from 'country-region-data/data.json';
import Select from 'react-select';

import { helpText, labelClasses } from './common';

const CANADA = 'CA';
const UNITED_KINGDOM = 'GB';
const UNITED_STATES = 'US';

const validCountries = [
  CANADA, // Canada
  UNITED_STATES, // United States
  // 'AU', // Australia
  // 'NZ', // New Zealand
  UNITED_KINGDOM // United Kingdom
];

const countryCodeMap = CountryRegionData.reduce((acc, country) => {
  acc[country.countryShortCode] = country;
  return acc
}, {});

const countryForCode = (code) => {
  const country = countryCodeMap[code];
  if (!country) return null;
  return { value: country.countryShortCode, label: country.countryName };
}

const validCountryOptions = CountryRegionData
  .filter(({ countryShortCode }) => validCountries.includes(countryShortCode))
  .map(country => ({ value: country.countryShortCode, label: country.countryName }));

const CountrySelect = ({ formik, onChange, schema }) => (
  <div className="field">
    <label className={labelClasses(schema, 'country')} htmlFor="country">Country</label>
    <Select
      isClearable={true}
      id="country"
      instanceId="country"
      onChange={e => onChange(e?.value || '')}
      onBlur={formik.handleBlur}
      value={countryForCode(formik.values.country)}
      clearValue={() => ''}
      options={validCountryOptions} />
    {helpText(formik, 'country')}
  </div>
);

const countryRegionOverrides = {
  [UNITED_KINGDOM]: [
    { name: 'Scotland' },
    { name: 'Northern Ireland' },
    { name: 'Wales' },
    { name: 'North East' },
    { name: 'North West' },
    { name: 'Yorkshire and the Humber' },
    { name: 'West Midlands' },
    { name: 'East Midlands' },
    { name: 'South West' },
    { name: 'South East' },
    { name: 'East of England' },
    { name: 'Greater London' }
  ]
}

const getCountryRegions = (countryCode) => {
  const country = countryCodeMap[countryCode];
  return countryRegionOverrides[countryCode] || country?.regions || [];
};

const CountrySelectSimple = ({ onChange, placeholder, value }) => (
  <Select
    isClearable={true}
    id="country"
    instanceId="country"
    onChange={value => onChange(value?.value)}
    value={countryForCode(value)}
    placeholder={placeholder}
    options={validCountryOptions} />
);

export default CountrySelect;
export {
  countryCodeMap,
  countryForCode,
  CountrySelectSimple,
  getCountryRegions,
  validCountries,
  validCountryOptions
};
